import ActivityIcon from '@/icons/menu/ActivityIcon';
import EditSquare from '@/icons/menu/EditSquare';
import WorkIcon from '@/icons/menu/WorkIcon';
import type { MenuSection } from '../types';

export const hiringMenu = () =>
  ({
    type: 'section',
    id: 'hiring',
    label: 'Hiring',
    children: [
      {
        type: 'link',
        id: 'hiring-job-post',
        label: 'Job Post',
        href: '/job-post',
        matchPaths: [/^\/job-post([^\/]+)$/],
        icon: ({ isActive }) =>
          isActive ? (
            <EditSquare.Primary className="shrink-0 text-xs text-violet-500 !size-3" />
          ) : (
            <EditSquare className="shrink-0 text-xs text-neutral-500 !size-3" />
          ),
      },
      {
        type: 'link',
        id: 'hiring-talent-search',
        label: 'Talent Search',
        href: '/explore-talents',
        matchPaths: [
          /^\/explore-talents([^\/]+)$/,
          /^\/explore-talents\/search(\/.*)?$/,
        ],
        exactMatch: true,
        icon: ({ isActive }) =>
          isActive ? (
            <WorkIcon.Primary className="shrink-0 text-xs text-violet-500 !size-3" />
          ) : (
            <WorkIcon className="shrink-0 text-xs text-neutral-500 !size-3" />
          ),
      },
      {
        type: 'link',
        id: 'hiring-analytics',
        label: 'Analytics',
        href: '/analytics',
        exactMatch: true,
        icon: ({ isActive }) =>
          isActive ? (
            <ActivityIcon.Primary className="shrink-0 text-xs text-violet-500 !size-3" />
          ) : (
            <ActivityIcon className="shrink-0 text-xs text-neutral-500 !size-3" />
          ),
      },
    ],
  }) as const satisfies MenuSection;
